module.exports = __webpack_public_path__ + "img/image-18.fdc454c7.jpg";